import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { FrontWeightDesignMode, type FrontWeightDesignTarget } from '@/lib/piano/touch-design/design/front-weight-design';
export const useFrontWeightRecommendation = (frontWeightDesignMode, frontWeightDesignTarget, setFrontWeightDesign) => {
  const $ = _c(5);
  const isFirstRender = useRef(true);
  let t0;
  let t1;
  if ($[0] !== frontWeightDesignMode || $[1] !== frontWeightDesignTarget || $[2] !== setFrontWeightDesign) {
    t0 = () => {
      if (isFirstRender.current) {
        if (frontWeightDesignTarget === null && frontWeightDesignMode === null) {
          setFrontWeightDesign(FrontWeightDesignMode.AsMeasured, null);
        }
        isFirstRender.current = false;
      }
    };
    t1 = [frontWeightDesignMode, frontWeightDesignTarget, isFirstRender, setFrontWeightDesign];
    $[0] = frontWeightDesignMode;
    $[1] = frontWeightDesignTarget;
    $[2] = setFrontWeightDesign;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};